import axiosInstance from "@/api/config";

import { EventSourceMessage } from "@microsoft/fetch-event-source";

import useEventSource from "../useEventSource";

export type UseExecutiveSummaryProps = {
  analysisId?: string;
  onDelta: (chunk: { content: string }, event: EventSourceMessage) => void;
  onFinal: (full: { content: string }, event: EventSourceMessage) => void;
};

export type ExecutiveSummaryHandlers = {
  "message:delta": { content: string };
  "message:final": { content: string };
};

export const useExecutiveSummary = ({
  analysisId,
  onDelta,
  onFinal
}: UseExecutiveSummaryProps) => {
  useEventSource<ExecutiveSummaryHandlers>({
    url: `${axiosInstance.defaults.baseURL}/v1/analysis/${analysisId}/executive-summary`,
    eventKey: "executive-summary",
    parse: JSON.parse,
    eventHandlers: {
      "message:delta": (data, event) => {
        onDelta(data, event);
      },
      "message:final": (data, event) => {
        onFinal(data, event);
      }
    },
    enabled: !!analysisId
  });
};
